import { render, staticRenderFns } from "./businessJuJin.vue?vue&type=template&id=5c649000&scoped=true&"
import script from "./businessJuJin.vue?vue&type=script&lang=ts&"
export * from "./businessJuJin.vue?vue&type=script&lang=ts&"
import style0 from "./businessJuJin.vue?vue&type=style&index=0&id=5c649000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c649000",
  null
  
)

export default component.exports